import Card from "antd/es/card/Card";
import styled from "styled-components";

export const ListsContainer = styled(Card)`
  max-width: 1000px;
`;
